import classNames from "classnames/dedupe";
import { AnimateSharedLayout, motion } from "framer-motion";
import PropTypes from "prop-types";
import React from "react";
/**
 *
 * @param {object} props
 * @param {any} [props.className]
 * @param {import("framer-motion").MotionStyle} [props.style]
 * @returns {JSX.Element}
 */

export const SkeletonBox = ({
  className,
  style
}) => {
  const boxClasses = classNames(["bg-en-gray-100", "animate-pulse"], className);
  return /*#__PURE__*/React.createElement(motion.div, {
    key: "skeleton",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      ease: "easeInOut"
    },
    className: boxClasses,
    style: style
  });
};
SkeletonBox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object
};
export const SkeletonParagraph = ({
  rows = 4,
  className,
  style
}) => {
  const rowClasses = classNames(["bg-en-gray-100", "animate-pulse", "h-4 mb-2", "w-full", "last:w-2/3"]);
  return /*#__PURE__*/React.createElement(motion.div, {
    key: "skeleton",
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      ease: "easeInOut"
    },
    className: className,
    style: style
  }, Array.from({
    length: rows
  }, (_, i) => /*#__PURE__*/React.createElement(SkeletonBox, {
    key: i,
    className: rowClasses
  })));
};
SkeletonParagraph.propTypes = {
  rows: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  style: PropTypes.object
};
export const Skeleton = ({
  paragraph,
  rows,
  className,
  isLoading,
  children,
  style
}) => {
  const showSkeleton = isLoading || !children;
  return /*#__PURE__*/React.createElement(AnimateSharedLayout, null, showSkeleton ? paragraph ? /*#__PURE__*/React.createElement(SkeletonParagraph, {
    className,
    style,
    rows
  }) : /*#__PURE__*/React.createElement(SkeletonBox, {
    className,
    style
  }) : /*#__PURE__*/React.createElement(motion.div, {
    key: "content",
    initial: {
      opacity: 0,
      scale: 0.95
    },
    animate: {
      opacity: 1,
      scale: 1
    },
    transition: {
      ease: "easeInOut"
    },
    exit: {
      opacity: 0
    },
    className: className,
    style: style
  }, children));
};
Skeleton.propTypes = {
  paragraph: PropTypes.bool,
  rows: PropTypes.number,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  style: PropTypes.object
};